import createTitleFabric from "../../../general/CoreHeader/components/Title/titleFabric";
import { createDisplayNameForHeaderShowAll } from "../../utils/createDisplayName";
import { createTestIdForHeaderShowAll } from "../../utils/createTestId";

const displayName = createDisplayNameForHeaderShowAll("Title");
const testId = createTestIdForHeaderShowAll("title");

const HeaderShowAllTitle = createTitleFabric(displayName, testId);

export default HeaderShowAllTitle;
